// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__VwU8x","tab":"tabs_tab__9z1Oy","active":"tabs_active__052Mp","slide":"tabs_slide__bSaUM"};